import _ from 'underscore';
import {
  Text,
  Panel,
  MessageBar,
  CustomComponent,
  PropertyRow,
  HorizontalDivider,
  Data,
} from './components';

export const componentTypes = {
  text: Text,
  panel: Panel,
  'message-bar': MessageBar,
  'property-row': PropertyRow,
  'horizontal-divider': HorizontalDivider,
  'custom-component': CustomComponent,
  data: Data,
};

export const register = (label, Component) => {
  componentTypes[label] = Component;
};

export const bulkRegister = (registrationMap) => {
  _.extend(componentTypes, registrationMap);
};
